import { CopyButton as FoundationsCopyButton } from 'foundations-components/transitional/components/CopyButton';
import FormattedMessage from 'I18n/components/FormattedMessage';
import QuotesLogger from 'quotes-ui-lib/tracking/quotesLogger';
import { getIsPublished, getIsPendingApproval, getIsPendingApprovalOrRejected, getIsInactive } from 'quotes-ui-lib/utils/status';
import { jsx as _jsx } from "react/jsx-runtime";
const CopyButton = ({
  quote,
  trackingLocation,
  templateType,
  fullQuoteUrl
}) => {
  const isPendingApproval = getIsPendingApproval(quote);
  const copyLinkMessage = isPendingApproval ? 'quotesUiLib.quoteActions.copy.copyApprovalLink' : 'quotesUiLib.quoteActions.copy.copyQuoteLink';
  const actionToTrack = isPendingApproval ? 'Copy quote approval link' : 'Copy quote link';
  const trackAction = action => {
    QuotesLogger.log('quoteInteraction', {
      action,
      location: trackingLocation,
      templateType
    });
  };
  return /*#__PURE__*/_jsx(FoundationsCopyButton, {
    "data-test-id": "copy-button",
    size: "extra-small",
    value: fullQuoteUrl,
    responsive: false,
    onClick: () => trackAction(actionToTrack),
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: copyLinkMessage
    })
  }, "copyButton");
};
export const showCopyButton = (quote, canCurrentUserEditQuote, fullQuoteUrl) => {
  const isPublished = getIsPublished(quote);
  const isPendingApprovalOrRejected = getIsPendingApprovalOrRejected(quote);
  const isInactive = getIsInactive(quote);
  const isPublishedAndActive = isPublished && !isInactive;
  return Boolean(fullQuoteUrl) && (isPublishedAndActive || isPendingApprovalOrRejected && canCurrentUserEditQuote);
};
export default CopyButton;